export default {"src":"/_next/static/media/export-report.c63c4bd8.svg","height":28,"width":29,"blurWidth":0,"blurHeight":0};